import React from 'react'
import queryString from 'query-string'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

export default function ({query}) {
  const newQuery = {...query, im: true}
  const openLink = `?${queryString.stringify(newQuery)}` 
  return (
    <Link to={openLink}>
      <Button>
        Add Image
      </Button>
    </Link>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ImageManagerOpenButton.js